import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/common/Navbar";
import Footer from "./components/common/Footer";
import "./App.css";
import OfferingB from "./pages/OfferingB";
import OfferingA from "./pages/OfferingA";
import CareerPage from "./pages/CareerPage";
import NotFound from "./pages/NotFound";
import AboutUs from "./pages/AboutUs";
import CareerPage2 from "./pages/CareerPage2";
import ContactUs from "./pages/ContactUs";
import BlogPost from "./pages/BlogPost";
import { ScreenProvider } from "./context/ScreenContext";
import ScrollToHash from "./components/common/ScrollToHash";
import { Toaster } from "react-hot-toast";
import AdminPage from "./pages/AdminPage";
import PrivacyPolicy from "./components/common/PrivacyPolicy";

// ✅ Import Sentry
import * as Sentry from "@sentry/react";

// ✅ Define a fallback component
const FallbackComponent = () => (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h2>Something went wrong.</h2>
    <p>We're working to fix it. Please try again later.</p>
  </div>
);

function App() {
  return (
    <div className="">
      {/* ✅ Wrap your app's main routes in Sentry ErrorBoundary */}
      <Sentry.ErrorBoundary fallback={<FallbackComponent />} showDialog>
        <ScreenProvider>
          <Router>
            <Navbar />
            <ScrollToHash />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/careers" element={<CareerPage />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/offering-b" element={<OfferingB />} />
              <Route path="/offering-a" element={<OfferingA />} />
              <Route path="/careers2" element={<CareerPage2 />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              {/* <Route path="/test" element={<Test />} /> */}
              <Route path="*" element={<NotFound />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/T8xZ4pW9qL/*" element={<AdminPage />} />
              <Route path="/admin/*" element={<AdminPage />} />
            </Routes>

            <Footer />
          </Router>
        </ScreenProvider>
        <Toaster />
      </Sentry.ErrorBoundary>
    </div>
  );
}

export default App;
